import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=4070a642&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Contact.vue?vue&type=style&index=0&id=4070a642&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4070a642",
  "05cbc50e"
  
)

export default component.exports